module.exports = __webpack_public_path__ + "static/img/n-two.82b0cdaa.png";